<ng-container *ngIf="videoControls.ready$ | async">
  <span data-test="current-time">{{
    (videoControls.currentTime$ | async) * 1000 | date : 'm:ss'
  }}</span>
  <span class="separator">/</span>
  <span data-test="duration">{{ (videoControls.duration$ | async) * 1000 | date : 'm:ss' }}</span>
</ng-container>
